import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AuthUser } from '@/types/auth.types';
import { tokenStorage } from '@/utils/token-storage.util';

export interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  rememberMe: boolean;
}

const initialState: AuthState = {
  user: null,
  accessToken: tokenStorage.getAccessToken(),
  isAuthenticated: Boolean(tokenStorage.getAccessToken()),
  rememberMe: false,
};

export interface SetCredentialsPayload {
  user: AuthUser;
  accessToken: string;
  refreshToken?: string;
  rememberMe?: boolean;
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<SetCredentialsPayload>) {
      const { user, accessToken, refreshToken, rememberMe = false } = action.payload;

      state.user = user;
      state.accessToken = accessToken;
      state.isAuthenticated = true;
      state.rememberMe = rememberMe;

      tokenStorage.setAccessToken(accessToken, rememberMe);

      if (refreshToken) {
        tokenStorage.setRefreshToken(refreshToken, rememberMe);
      }
    },
    setUser(state, action: PayloadAction<AuthUser>) {
      state.user = action.payload;
    },
    clearCredentials(state) {
      state.user = null;
      state.accessToken = null;
      state.isAuthenticated = false;
      state.rememberMe = false;

      tokenStorage.clearAll();
    },
  },
});

export const { setCredentials, setUser, clearCredentials } = authSlice.actions;
export const authReducer = authSlice.reducer;
